export default "__VITE_ASSET__CWF33ahv__"